// extracted by mini-css-extract-plugin
export default {"Custom_FormInput":"FormInput_Custom_FormInput__5h2HH"};